module.exports = __webpack_public_path__ + "static/media/b1_p11_clickable.8db91894.mp3";